module.exports = __webpack_public_path__ + "img/prodoctsec-top.c04734a9.png";